import {
  BookOpen01Icon,
  CubeIcon,
  File01Icon,
  HardDriveIcon,
  type TerraIcon,
} from '@terra/ui-icons';
import type { KnowledgeSyncProviderType } from '@terra/shared-contracts-knowledge-sync';
import { KNOWLEDGE_SYNC_PROVIDERS } from '@terra/shared-contracts-knowledge-sync';

type KnowledgeSourceProviderDisplay = {
  label: string;
  Icon: TerraIcon;
};
const PROVIDER_DISPLAY: Record<
  KnowledgeSyncProviderType,
  KnowledgeSourceProviderDisplay
> = {
  [KNOWLEDGE_SYNC_PROVIDERS.CONFLUENCE]: {
    label: 'Confluence',
    Icon: BookOpen01Icon,
  },
  [KNOWLEDGE_SYNC_PROVIDERS.NOTION]: {
    label: 'Notion',
    Icon: File01Icon,
  },
  [KNOWLEDGE_SYNC_PROVIDERS.GOOGLE_DRIVE]: {
    label: 'Google Drive',
    Icon: HardDriveIcon,
  },
  [KNOWLEDGE_SYNC_PROVIDERS.BOX]: {
    label: 'Box',
    Icon: CubeIcon,
  },
};

export function getKnowledgeSourceProviderDisplay({
  provider,
}: {
  provider: string;
}): KnowledgeSourceProviderDisplay {
  return (
    PROVIDER_DISPLAY[provider as KnowledgeSyncProviderType] ?? {
      label: provider,
      Icon: BookOpen01Icon,
    }
  );
}
